import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { HospitalServiceService } from './service/hospital-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-hospital-create',
  templateUrl: './hospital-create.component.html',
  styleUrls: ['./hospital-create.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HospitalCreateComponent implements OnInit {
  displayedColumns: string[] = ['no', 'hospitalnameth', 'packagename', 'status', 'expiredate_package', 'phone', 'action'];
  dataSource;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private _hospital : HospitalServiceService
  ) { }

  ngOnInit() {
    this.getHospital()
  }

  getHospital() {
    this._hospital.getHospitalAll().subscribe(hospitals => {
      // console.log(hospitals);
      for(let i = 0; i<hospitals['message'].length;i++){
        if(hospitals['message'][i]['status'] == 'Valid'){
          // console.log("green");
          hospitals['message'][i]["color"] = "green"
        }else{
          // console.log("red");
          hospitals['message'][i]["color"] = "red"
        }
      }
      console.log(hospitals['message']);
      this.dataSource = new MatTableDataSource(hospitals['message'])
      this.dataSource.paginator = this.paginator;
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  dialog_addHospital(){
    const dialogRef = this.dialog.open(dialog_add_hospital, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getHospital()
    })
  }

  editHospital(data: any) {
    localStorage.setItem('dataEdit', JSON.stringify(data))
    // console.log(data);
    const dialogRef = this.dialog.open(dialog_edit_hospital, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getHospital()
      localStorage.removeItem('dataEdit')
    })
  }

  // Dialog Delete
  dialog_deleteHospital(id: any): void {
    localStorage.setItem('id', id)
    const dialogRef = this.dialog.open(dialog_delete_hospital, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getHospital()
      localStorage.removeItem('id')
    })
  }

}

@Component({
  selector: 'dialog_add_hospital',
  templateUrl: 'dialog-add-hospital.html',
  styleUrls: ['hospital-create.component.scss']
})
export class dialog_add_hospital implements OnInit {
  // ceate form add
  formAdd: FormGroup;
  hospitalAPI = `${environment.apiUrl}/hospitals`;
  packageAPI = `${environment.apiUrl}/package`;
  list_package : any
  packages: any = [];
  filteredOptions: Observable<string[]>;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };
  constructor(
    public dialogRef: MatDialogRef<dialog_add_hospital>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.formAddHospital() 
  }

  ngOnInit() {
    this.getPackage()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formAddHospital() {
    this.formAdd = this.formBuilder.group({
      package_name: ['', Validators.required],
      hospital_name_th: ['', Validators.required],
      tel: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      // email: ['', [Validators.email, Validators.required]],
      no: ['142/135', Validators.required],
      district: ['1', Validators.required],
      county: ['', Validators.required]
    })
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.packages.filter(option => option.toLowerCase().includes(filterValue));
  }

  getPackage() {
    this.http.get(this.packageAPI, this.httpOptions).subscribe(packages => {
      // console.log(packages);
      this.list_package = packages
      for(let i of this.list_package){
        this.packages.push(i['package_name'])
      }
      this.filteredOptions = this.formAdd.get('package_name').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    })
  }

  addHospital() {
    // console.log(this.formAdd.value);
    if (this.formAdd.invalid) return;
    this.http.post(this.hospitalAPI, this.formAdd.value, this.httpOptions).subscribe(res => {
      // console.log(res);
      this.onNoClick()
      this._snackBar.open('Add hospital success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Add hospital fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_edit_hospital',
  templateUrl: 'dialog-edit-hospital.html',
  styleUrls: ['hospital-create.component.scss']
})
export class dialog_edit_hospital implements OnInit {
  data_edit = JSON.parse(localStorage.getItem('dataEdit'))
  // ceate form add
  formEdit: FormGroup;
  hospitalAPI = `${environment.apiUrl}/hospitals`;
  packageAPI = `${environment.apiUrl}/package`;
  list_package : any
  packages: any = [];
  filteredOptions: Observable<string[]>;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_edit_hospital>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.formEditHospital()
  }

  ngOnInit() {
    this.setDataEdit()
    this.getPackage()
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.packages.filter(option => option.toLowerCase().includes(filterValue));
  }

  getPackage() {
    this.http.get(this.packageAPI, this.httpOptions).subscribe(packages => {
      console.log(packages);
      this.list_package = packages
      for(let i of this.list_package){
        this.packages.push(i['package_name'])
      }
      this.filteredOptions = this.formEdit.get('package_name').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formEditHospital() {
    this.formEdit = this.formBuilder.group({
      hospital_id: [''],
      package_name: ['', Validators.required],
      hospital_name_th: ['', Validators.required],
      tel: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      county: ['', Validators.required],
      status: ['', Validators.required],
      year: ['', Validators.required],
    })
  }

  setDataEdit() {
    this.formEdit.controls['hospital_id'].setValue(this.data_edit['hospital_id'])
    this.formEdit.controls['package_name'].setValue(this.data_edit['package_name'])
    this.formEdit.controls['hospital_name_th'].setValue(this.data_edit['hospital_name_th'])
    this.formEdit.controls['tel'].setValue(this.data_edit['tel'])
    this.formEdit.controls['county'].setValue(this.data_edit['county'])
    this.formEdit.controls['status'].setValue(this.data_edit['status'])
    this.formEdit.controls['year'].setValue(this.data_edit['year'])
  }

  editHospital() {
    // check ส่งเท่าที่จำเป็น ////////////
    if(this.formEdit.value.package_name == this.data_edit['package_name']){
      this.formEdit.get('package_name').disable()
    }
    if(this.formEdit.value.hospital_name_th == this.data_edit['hospital_name_th']){
      this.formEdit.get('hospital_name_th').disable()
    }
    if(this.formEdit.value.tel == this.data_edit['tel']){
      this.formEdit.get('tel').disable()
    }
    if(this.formEdit.value.county == this.data_edit['county']){
      this.formEdit.get('county').disable()
    }
    if(this.formEdit.value.status == this.data_edit['status']){
      this.formEdit.get('status').disable()
    }
    if(this.formEdit.value.year == this.data_edit['year']){
      this.formEdit.get('year').disable()
    }
    ///////////////////////////////
    if(this.formEdit.invalid) return
    console.log('data edit: ',this.formEdit.value);
    this.http.put(`${this.hospitalAPI}?hospital_id=${this.formEdit.value.hospital_id}`, this.formEdit.value, this.httpOptions).subscribe(res => {
      // console.log(res);
      this.onNoClick()
      this._snackBar.open('Edit hospital success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Edit hospital fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}

@Component({
  selector: 'dialog_delete_hospital',
  templateUrl: 'dialog-delete-hospital.html',
  styleUrls: ['hospital-create.component.scss']
})
export class dialog_delete_hospital implements OnInit {
  data_id = localStorage.getItem('id')
  hospitalAPI = `${environment.apiUrl}/hospitals?hospital_id=${this.data_id}`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_delete_hospital>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteHospital() {
    this.http.delete(this.hospitalAPI, this.httpOptions).subscribe(data => {
      // console.log('Delete Success', data);
      this.onNoClick()
      this._snackBar.open('Delete hospital success.', 'Done', {
        duration: 3000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Delete hospital fail!.', 'Done', {
        duration: 3000,
      });
    })
  }

}
